import { PortfolioRepo as portfolioRepo } from '@services/portfolio.repo';
import { PortfolioUtilities as portfolioUtilities } from '@common/portfolio.utilities';
import { portfolioSelectorService } from '../../portfolioSelector';
import * as echarts from 'echarts';

class PortfolioMauritiusEquityController {

  public equityItems: any;
  public marketValue: any;
  public equitiesTotal: any = 0;
  chartEquityHeight: any;

  public equityPieChart : any;
  public equityPieChartOptions : any;
  public equityPieChartData : any;

  public getMarketValue: (any) => any;
  public getEquityPercentage: (any) => any;

  /** @ngInject */
  constructor(private portfolioRepo: portfolioRepo, private portfolioUtilities: portfolioUtilities, private portfolioSelectorService : portfolioSelectorService,
              private $timeout: ng.ITimeoutService, private notifyjs) {

    var that = this;

    this.portfolioSelectorService.registerCallback('portfolio.mauritius.equity', () => { this.updateData() }); // Need to wrap it in a fat arrow functiom to get the correctly scoped this
    
    this.updateData();
    this.getMarketValue = (equities: any) => {
      return equities.marketValueDisplayCurrency;
    }


    this.getEquityPercentage = (equities: any) => {

      return (this.getMarketValue(equities) / this.equitiesTotal) * 100;
    }
  }

  public formatCurrency() {
    if(!this.portfolioSelectorService.isLoading){
      return this.portfolioUtilities.formatCurrency(this.portfolioSelectorService.getSelectedCurrency());
    }else{
      return "";
    }
  }

  public scrollToElement(elementId: string) {
    var that = this;
    this.$timeout(function () { that.portfolioUtilities.scrollToElement(elementId); }, 220);
  }

  public initialisePieChart () {
    // need to put the initialisation of the pie chart in a function because the dom element is not available till 
    // the time you have clicked on the pie chart tab.
    var that = this;
    that.equityPieChart = echarts.init(document.getElementById('equity-pie-chart'));
    that.equityPieChartOptions = {
      tooltip: {
        trigger: 'item',
        formatter: "{b} : {d}%"
      },
      color : ["#cc501e","#ff6526","#ff8351", "#ffa27c"], // ['#ffa500', '#ffb732','#ffc966'],
      series: {
        type: 'pie',
        radius: ['40%', '70%'],
        center: ['50%', '50%'],
        labelLine: {
          normal: {
            show: true
          }
        },
        data: that.equityPieChartData
      }
      
    }
    that.equityPieChart.setOption(that.equityPieChartOptions); 

  }

  updateData() {
    var that = this;
    this.portfolioSelectorService.setIsLoading(true);
    // Equity data
    that.portfolioRepo.getPortfolioEquityItems(this.portfolioSelectorService.getSelectedCurrency(), "LOCAL", this.portfolioSelectorService.getSelectedPortfolios())
      .then((val) => {
        
        that.equityItems = val.data;


        that.scrollToElement('equity');

        that.equityPieChartData = new Array();
        for (var s of this.equityItems) {
          this.equitiesTotal += this.getMarketValue(s);
          that.equityPieChartData.push({
            name : s.equityItem.name,
            value : this.getMarketValue(s)
          });
        }
        this.portfolioSelectorService.setIsLoading(false);
      })
      .catch ((err) => {
        this.portfolioSelectorService.setIsLoading(false);
        this.notifyjs("The equity data for the selected portfolios could not be loaded. Please try again later or contact the System Administrator.", "error");
      });
  }
}

export const portfolioMauritiusEquity: angular.IComponentOptions = {
  template: require('../portfolio.mauritius.equity/portfolio.mauritius.equity.html'),
  controller: PortfolioMauritiusEquityController
}



// WEBPACK FOOTER //
// ./src/app/portfolio/portfolio.mauritius/portfolio.mauritius.equity/portfolio.mauritius.equity.ts